export var METHODS;
(function (METHODS) {
    METHODS["GET"] = "get";
    METHODS["POST"] = "post";
    METHODS["PUT"] = "put";
    METHODS["PATCH"] = "PATCH";
    METHODS["DELETE"] = "delete";
})(METHODS || (METHODS = {}));
